import React from "react";

const teamMembers = [
  {
    name: "Advocate Sanjay Kumar Singh",
    image: "/images/team.png",
    facebook: "#",
    instagram: "#",
    linkedin: "#",
  },
  {
    name: "Er. Abhijeet Kumar Verma",
    image: "/images/team.png",
    facebook: "#",
    instagram: "#",
    linkedin: "#",
  },
  {
    name: "Amandeep Kumar",
    image: "/images/team.png",
    facebook: "#",
    instagram: "#",
    linkedin: "#",
  },
  {
    name: "Sanjay Kumar Patel",
    image: "/images/team.png",
    facebook: "#",
    instagram: "#",
    linkedin: "#",
  },
];

const ExpertTeam: React.FC = () => {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-white py-16">
      {/* Header */}
      <div className="max-w-6xl mx-auto text-center mb-10 px-6">
        <p className="text-red-600 font-semibold flex justify-center items-center gap-2">
          <span>⚙️</span> We are Dedicated
        </p>
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2">
          Our Expert Team
        </h2>
        <p className="text-gray-600 mt-3 max-w-2xl mx-auto text-sm leading-relaxed">
          Our team of experienced professionals is dedicated to delivering
          excellence in every project, ensuring innovative solutions and
          unparalleled quality.
        </p>
      </div>

      {/* Team Grid */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 px-4">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className="bg-white shadow-md hover:shadow-xl rounded-xl overflow-hidden transform hover:-translate-y-2 transition-all duration-300"
          >
            {/* Image */}
            <div className="w-full h-60 overflow-hidden">
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
              />
            </div>

            {/* Content */}
            <div className="p-4 text-center">
              <h3 className="text-base font-bold text-gray-900">
                {member.name}
              </h3>

              {/* Social Icons (Black + Royal Gold) */}
              <div className="flex justify-center gap-3 mt-3">
                {/* Facebook */}
                <a
                aria-label="Facebook profile"
                  href={member.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-black text-yellow-400 hover:bg-yellow-400 hover:text-black transition"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 320 512"
                  >
                    <path d="M279.14 288l14.22-92.66h-88.91V127.82c0-25.35 
                      12.42-50.06 52.24-50.06h40.42V6.26S293.3 0 
                      268.1 0c-73.22 0-121.1 44.38-121.1 
                      124.72v70.62H86.4V288h60.6v224h92.66V288z" />
                  </svg>
                </a>

                {/* Instagram */}
                <a
                aria-label="Facebook profile"
                  href={member.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-black text-yellow-400 hover:bg-yellow-400 hover:text-black transition"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 448 512"
                  >
                    <path d="M224.1 141c-63.6 0-114.9 
                      51.3-114.9 114.9s51.3 114.9 114.9 
                      114.9 114.9-51.3 
                      114.9-114.9S287.7 141 224.1 
                      141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 
                      74.7-74.7 74.7 33.5 74.7 
                      74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 
                      14.9-12 26.8-26.8 26.8-14.9 
                      0-26.8-12-26.8-26.8s12-26.8 
                      26.8-26.8 26.8 12 26.8 
                      26.8zm76.1 27.2c-1.7-35.7-9.9-67.3-36.2-93.5s-57.8-34.5-93.5-36.2c-37-2.1-147.9-2.1-184.9 
                      0-35.7 1.7-67.3 9.9-93.5 
                      36.2s-34.5 57.8-36.2 
                      93.5c-2.1 37-2.1 147.9 
                      0 184.9 1.7 35.7 9.9 67.3 
                      36.2 93.5s57.8 34.5 93.5 
                      36.2c37 2.1 147.9 2.1 184.9 
                      0 35.7-1.7 67.3-9.9 93.5-36.2 
                      26.3-26.2 34.5-57.8 36.2-93.5 
                      2.1-37 2.1-147.8 0-184.8z" />
                  </svg>
                </a>

                {/* LinkedIn */}
                <a
                aria-label="Facebook profile"
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-black text-yellow-400 hover:bg-yellow-400 hover:text-black transition"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 448 512"
                  >
                    <path d="M100.28 448H7.4V148.9h92.88zM53.79 
                      108.1C24.09 108.1 0 83 0 
                      53.4 0 23.7 24.1-1.4 
                      53.8-1.4c29.6 0 53.7 
                      25.1 53.7 54.8 0 29.6-24.1 
                      54.7-53.7 54.7zM447.9 
                      448h-92.4V302.4c0-34.7-12.4-58.4-43.3-58.4-23.6 
                      0-37.6 15.8-43.8 
                      31.1-2.3 5.6-2.9 
                      13.4-2.9 21.2V448h-92.4s1.2-262.9 
                      0-289.1h92.4v41c12.3-19 
                      34.2-46 83.4-46 60.9 0 
                      106.6 39.8 106.6 
                      125.4V448z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExpertTeam;
